import { render, staticRenderFns } from "./PosterTextWooCommerce.vue?vue&type=template&id=664a62b1&scoped=true&"
import script from "./PosterTextWooCommerce.vue?vue&type=script&lang=js&"
export * from "./PosterTextWooCommerce.vue?vue&type=script&lang=js&"
import style0 from "./PosterTextWooCommerce.vue?vue&type=style&index=0&id=664a62b1&lang=scss&scoped=true&"
import style1 from "./PosterTextWooCommerce.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a62b1",
  null
  
)

export default component.exports